<script>
import { mapActions } from 'vuex'

export default {
  name: 'UpdateTrackingCodeModal',
  props: {
    orderItem: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      form: {
        external_id: '',
        tracking_code: '',
      },
    }
  },
  computed: {
    itemId() {
      return this.orderItem.id
    },
    orderId() {
      return this.orderItem.orderId
    },
  },
  created() {
    const { form, orderItem } = this

    form.external_id = orderItem.externalId || ''
    form.tracking_code = orderItem.trackingCode || ''
  },
  methods: {
    ...mapActions('order', ['updateOrderItem']),
    validate() {
      return this.$refs.form.validate().catch(() => false)
    },
    async onSubmit() {
      const formIsValid = await this.validate()

      if (!formIsValid) {
        return
      }

      this.loading = true
      const { orderItem: { id, orderId }, form } = this

      const response = await this.updateOrderItem({ id, orderId, form })

      this.$notifier({
        response,
        errorTitle: 'Unable to update the order item',
        successTitle: 'Success',
        successMsg: 'Tracking Code has been updated',
      })
        .then(data => new Promise(resolve => setTimeout(() => resolve(data), 2000)))
        .then(success => {
          if (success) {
            this.loading = false
            this.$modal.self.hide()
            this.$emit('updated')
          }
        }).catch(() => {
          this.loading = false
        })
    },
    close() {
      this.$refs.modal.hide() // Need to check form changes
    },
  },
}
</script>

<template>
  <base-modal
    ref="modal"
    title="Update Tracking Code"
    :check-form-changes="form"
  >
    <el-form
      ref="form"
      label-position="left"
      label-width="110px"
      :model="form"
      :disabled="loading"
    >
      <el-form-item
        prop="external_id"
        label="External ID"
        required
      >
        <el-input
          v-model="form.external_id"
          disabled
        />
      </el-form-item>
      <el-form-item
        prop="tracking_code"
        label="Tracking Code"
        required
      >
        <el-input v-model="form.tracking_code" />
      </el-form-item>
    </el-form>

    <div :class="$style.buttonsWrap">
      <el-button
        :class="$style.button"
        type="primary"
        :disabled="loading"
        @click="onSubmit"
      >
        Save
      </el-button>
      <el-button
        :class="$style.button"
        type="danger"
        :disabled="loading"
        @click="close"
      >
        Cancel
      </el-button>
    </div>
  </base-modal>
</template>

<style lang="scss" module>
  .buttonsWrap {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 2rem;
  }

  .button {
    width: 100%;

    &:first-child {
      margin-right: 2rem;
    }
  }
</style>
